import React from 'react';
import { API_URL } from '../../../constants/api';
import { apiBatchRequest } from '../../../utils/api_service';
import { ShowToast, toastType } from '../../../utils/toast-service';
import commonLabels from '../../../constants/messageConstants';
import { UpdateFieldsWithConfiguration } from '../../../utils/helper';
import FormGenerator from '../../common/FormGenerator';

class EmployeeDetails extends React.Component {
  constructor (props) {
    super(props);
    this.state = { EmployeeDetails: undefined };
  }

  componentDidMount () {
    //  const query = useQuery();

    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.Employee.GetEmployeeDetails,
        key: 'EmployeeDetailsData',
        params: { employeeId: this.props.selectedEmployeeId }
      }
    ])
      .then(({ EmployeeDetailsData }) => {
        if (EmployeeDetailsData.success === true) {
          this.setState({
            EmployeeDetailsData: EmployeeDetailsData.data
          });
        } else {
          ShowToast(commonLabels.somethingWrong, toastType.ERROR, 5000, 500, 'Server error');
        }
      })
      .catch(() => {
        this._asyncRequest = null;
        ShowToast(commonLabels.somethingWrong, toastType.ERROR, 5000, 500, 'Server error');
      })
      .catch(() => {
        this._asyncRequest = null;
      });
  }

  render () {
    const { EmployeeDetailsData } = this.state;
    return (
      <>
        {EmployeeDetailsData && <FormGenerator gridColumn={2}
          formFields={UpdateFieldsWithConfiguration(EmployeeDetailsData, [])}
          dropDownSource={[]}
        ></FormGenerator>}
      </>
    );
  }
}

export default EmployeeDetails;
